const removeFalseyExcept0 = <T>(x: T | undefined | null | false | ''): x is T =>
  x !== undefined && x !== null && x !== false;
export default removeFalseyExcept0;
